import React, { useEffect, useRef, useState } from 'react';
import { Linking, Platform, ScrollView, StyleSheet, TextInput, TouchableOpacity, View } from 'react-native'

import api from "@/utils/api"
import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import { Image } from 'expo-image';


import { useController, useForm } from 'react-hook-form';
// import ImageCapture from '../../components/ImageCapture';
import { useDropzone } from 'react-dropzone';
import IcomoonIcon from '@/components/IcomoonIcon';
import { Illustration } from '@/components/Illustration';



// const thumb = {
//   display: 'inline-flex',
//   borderRadius: 2,
//   border: '1px solid #eaeaea',
//   marginBottom: 8,
//   marginRight: 8,
//   width: 100,
//   height: 100,
//   padding: 4,
//   boxSizing: 'border-box'
// };

// const thumbInner = {
//   display: 'flex',
//   minWidth: 0,
//   overflow: 'hidden'
// };

const img = {
  display: 'block',
  width: 'auto',
  height: '100%'
};


function Previews({ title, uploadUrl, extraData = {}, defaultImage = null, deleteUrl = null, onFileDelete = null, onFileCreated = null, uploadedAt=null }) {
  const [files, setFiles] = useState([]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': [],
      'application/pdf': [],
    },
    disabled: !! defaultImage,
    onDrop: acceptedFiles => {
      setFiles(acceptedFiles.map(file => Object.assign(file, {
        // preview: file.type.startsWith('image/') ? URL.createObjectURL(file) : "pdf",
        preview: URL.createObjectURL(file)
      })));
    }
  });

  const { isUploading, uploadProgress, error, uploadFile } = useUploadFiles();


  useEffect(() => {
    if(error){
      alert(error)
    }
  }, [error]);


  const thumbs = files.map(file => (
    <div style={tw`w-full h-full`} key={file.name}>
      <div style={tw`w-full h-full items-center justify-center`}>
        {
          file.type.startsWith('image/') ?
            <img
              src={file.preview}
              style={tw.style(`w-[50px] h-[50px] self-center`)}
              // Revoke data uri after image is loaded
              onLoad={() => { URL.revokeObjectURL(file.preview) }}
            />
          :
            <Illustration name="pdfIcon" width={50} height={50} style={tw`self-center`} />
            // <View style={tw`py-4 px-4 absolute top-[30px] left-[32px] bg-gray-200 rounded`}>
            // </View>
        }
      </div>
    </div>
  ));

  useEffect(() => {
    if(files){
      files.forEach(file => {
        // console.log(file)
        uploadFile(file, uploadUrl, extraData, onFileCreated)
          
      })
    }
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    return () => files.forEach(file => URL.revokeObjectURL(file.preview));
  }, [files]);


  return (
    <section >
      <input {...getInputProps()} />

      <div style={tw`w-[130px] mb-4`}>
        <div
          {...getRootProps({ className: 'dropzone' })}
          style={tw.style(`flex flex-col relative h-[180px] rounded-xl border border-gray-200 items-center bg-white`, { cursor: 'pointer', borderStyle: 'solid' })}
        >
          <View style={tw`flex h-[100px] w-full items-center justify-center`}>
            {
              (files.length == 0 && !defaultImage) &&
                <View style={tw`h-12 w-12 rounded-full border-2 border-secondary items-center justify-center self-center`}>
                  <IcomoonIcon name='add1' size={18} color={tw.color('secondary')} />
                </View>
            }

            {
              files.length > 0 &&
                <aside style={tw`flex h-full overflow-hidden`}>
                  {thumbs}
                </aside>
            }

            {
              (isUploading) &&
                <View style={tw`h-2 w-full bg-gray-200 absolute bottom-0 left-0 right-0 top-0 rounded-b`}>
                  <View style={tw`absolute bg-blue-400 left-0 top-0 h-2 w-[${Math.floor(uploadProgress)}px]`}></View>
                </View>
            }

            {
              !! defaultImage &&
                <FilePreview fileUrl={defaultImage} deleteUrl={deleteUrl} onFileDelete={onFileDelete} />
            }
          </View>

          <View style={tw`px-2`}>
            <Text style={tw`text-gray-800 text-center text-sm font-500`}>{title}</Text>
            {
              uploadedAt &&
                <Text style={tw`text-center text-gray-400 text-xs mt-1`}>Subido el {uploadedAt}</Text>
            }
          </View>
        </div>
      </div>
    </section>
  );
}


function FilePreview({ fileUrl, deleteUrl, onFileDelete}){
  const confirmDelete = () => {
    if(confirm('¿Eliminar documento?')){
      deleteFile()
    }
  }

  const deleteFile = () => {
    api.delete(deleteUrl)
    .then(() => {
      onFileDelete()
    })
    .catch(() => {
      
    })
  }
  
  return (
    <View style={tw`w-full h-full relative`}>
      <TouchableOpacity
        onPress={() => Linking.openURL(fileUrl)}
        style={tw`w-full h-full items-center justify-center`}
      >
        {
          fileUrl.includes(".pdf") ?
            <Illustration name="pdfIcon" width={44} height={54} />
          :
            <Image source={fileUrl} style={tw`w-full h-full`} contentFit="contain" />
        }
      </TouchableOpacity>

      <TouchableOpacity
        onPress={confirmDelete}
        style={tw`h-6 w-6 rounded-full bg-red-500 flex items-center justify-center absolute right-1 top-1`}
      >
        <Text style={tw`text-white text-xs`}>✕</Text>
      </TouchableOpacity>
    </View>
  )
}




// Checar
// https://taylor.callsen.me/ajax-multi-file-uploader-with-native-js-and-promises/

export default function PictureContainer({ 
  title, image, control, name, rules, uploadUrl, extraData, defaultImage, deleteUrl, onFileDelete, onFileCreated, uploadedAt
}) {
  const [showCapture, setShowCapture] = useState(false);
  const [capturedPic, setCapturedPic] = useState();
  // const { field, fieldState: { invalid, isTouched, isDirty, error } } = useController({
  //   control: control,
  //   defaultValue: '',
  //   name: name,
  //   rules: rules,
  // })

  return (
    <Previews
      title={title}
      uploadUrl={uploadUrl}
      extraData={extraData}
      defaultImage={defaultImage}
      deleteUrl={deleteUrl}
      onFileDelete={onFileDelete}
      onFileCreated={onFileCreated}
      uploadedAt={uploadedAt}
    />
  )
  return (
    <>
      <TouchableOpacity
        style={tw`flex-1 bg-gray-100 rounded-lg items-center justify-center px-2 py-4`}
        onPress={() => setShowCapture(true)}
      >
        <Text style={tw`text-gray-500 font-bold`}>{title}</Text>

        {
          !capturedPic ?
            <>
              <Image
                source={image}
                style={tw`h-18 w-32 my-4`}
                contentFit="contain"
              />

              <Text style={tw`text-primary`}>Tomar Foto {">"}</Text>
            </>
            :
            <Image source={capturedPic.image.uri} style={tw`w-30 h-30 mt-2`} contentFit="cover" />
        }
      </TouchableOpacity>

    </>
  )
}


function useUploadFiles(){
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(50);
  const [error, setError] = useState(null);
  const [responseData, setResponseData] = useState(null);

  const uploadFile = async (fileData, uploadUrl, extraData = {}, onFileUploaded=null, fileKey="file") => {
    const formData = new FormData();
    formData.append(fileKey, fileData);
    
    for (const key in extraData) {
      if (extraData.hasOwnProperty(key)) {
        formData.append(key, extraData[key]);
      }
    }

    setIsUploading(true);
    setUploadProgress(0);
    setError(null);

    try {
      const response = await api.post(uploadUrl, formData, {
        timeout: 40000,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress(percent);
            console.log("uploadPercent", percent)
          }
        },
      });
      
      onFileUploaded?.()

      setResponseData(response.data);  // Aquí guardas la respuesta del servidor
    } catch (err) {
      setError(err.message);
    } finally {
      setIsUploading(false);
    }
  
    // return api.post("/images", formData, {
    //   headers: { "Accept": "application/json", "Content-Type": "multipart/form-data" },
    //   timeout: 60000,
    //   // onUploadProgress,
    // })
    //   .then(({ data }) => {
    //     // console.log(data);
  
    //     return data
    //   })
  }


  async function uploadAllImages(images) {
    return new Promise(async (resolve, reject) => {
      const checkinImages = {}
  
      updateUploadedImagesCount(Object.keys(images).length, 0)
  
      try {
        await Promise.all(Object.keys(images).map(async (imageKey) => {
          const image = images[imageKey]
  
          if (image.uploaded) {
            checkinImages[imageKey] = image.info
            updateUploadedImagesCount(Object.keys(images).length, uploadedImagesCount.current + 1)
            return
          }
  
          let imageData;
  
          if (Platform.OS === "web") {
            // web
            imageData = await fetchImageFromUri(image.image.uri)
          } else {
            // native
            // imageData = await FileSystem.readAsStringAsync(image.image.uri) // , { encoding: "base64" }
  
            const localUri = Platform.OS === 'ios' ? image.image.uri.replace('file://', '') : image.image.uri
            const filename = localUri.split('/').pop();
  
            // Infer the type of the image
            const match = /\.(\w+)$/.exec(filename);
            const type = match ? `image/${match[1]}` : `image/jpeg`;
  
            imageData = {
              name: "image.jpg",
              type: type,
              uri: localUri,
            }
          }
  
          const uploadedImg = await uploadImage(imageData)
  
          const newImgs = {
            ...images,
          }
  
          newImgs[imageKey].uploaded = true
          newImgs[imageKey].info = uploadedImg
          newImgs[imageKey].url = uploadedImg.url
  
          setValue("pictures", newImgs)
  
          updateUploadedImagesCount(Object.keys(images).length, uploadedImagesCount.current + 1)
  
  
          // 
          checkinImages[imageKey] = uploadedImg
        }))
      } catch (e) {
        reject(e)
      }
  
      resolve(checkinImages)
    });
  }


  return {
    isUploading,
    uploadProgress,
    error,
    responseData,
    uploadFile,
  };
}



